import { Typography } from '@klp/design/Typography';
import type { Aktivitet } from '@klp/formgenerator/interfaces';
import { Alert } from '@material-ui/lab';
import React from 'react';
import { TildelAnsvarligSelector } from './TildelAnsvarligSelector';
import { useCurrentUser } from '@klp/auth';
import { getLocalizedRoles } from '@klp/formgenerator/utils';
import { useFormContext } from '@klp/formgenerator/context/FormContext';

type TildelAnsvarligInfoboxProps = {
    isDisabled: boolean;
    prosjektId: string;
    prosessInstansId: string;
    activity: Aktivitet;
    redirectTo?: string;
};
export const TildelAnsvarligInfobox: React.FC<TildelAnsvarligInfoboxProps> = ({
    isDisabled,
    prosjektId,
    prosessInstansId,
    activity,
    redirectTo,
}) => {
    const { currentUser, isEDAdmin } = useCurrentUser();
    const isCurrentUserAssigned = currentUser?.epost === activity.tildeltTil;
    const { regionContext } = useFormContext();

    if (isDisabled) return null;
    if (!isCurrentUserAssigned && !isEDAdmin) return null;

    return (
        <Alert severity="info" icon={false}>
            <Typography variant="h2" translation="formGenerator.assign.title" />

            <Typography
                paddingVertical="compact"
                translation="formGenerator.assign.description"
                translationOptions={{
                    oppgave: activity.navn,
                    rolle: getLocalizedRoles(activity.kandidatGruppe),
                }}
            />

            {activity.kandidatGruppe && (
                <TildelAnsvarligSelector
                    prosjektId={prosjektId}
                    prosessInstansId={prosessInstansId}
                    kandidatGruppe={activity.kandidatGruppe}
                    currentAnsvarlig={activity.tildeltTil}
                    redirectTo={redirectTo}
                    activity={activity}
                    endreProsessAnsvarlig={false}
                    region={regionContext}
                />
            )}
        </Alert>
    );
};
